import type { FormItem, FormItemType } from '@/types/appointmentForm';
import type { QuestionDefinition, QuestionVersion } from '@/types/formsEngine';

export function currentPublishedQuestion(question: QuestionDefinition): QuestionVersion | null {
  return (
    question.versions.find(
      (version) => version.state === 'PUBLISHED' && version.version === question.currentVersion,
    ) ??
    question.versions.find((version) => version.state === 'PUBLISHED') ??
    null
  );
}

export function isQuestionSupportedByLegacyBuilder(question: QuestionDefinition): boolean {
  const version = currentPublishedQuestion(question);
  return Boolean(version && builderItemType(version.type));
}

export function questionToBuilderItem(
  question: QuestionDefinition,
  sortOrder: number,
): FormItem | null {
  const version = currentPublishedQuestion(question);
  if (!version) return null;
  const type = builderItemType(version.type);
  if (!type) return null;

  return {
    placementKey: undefined,
    questionId: question.id,
    questionVersionId: version.id,
    isLibraryItem: true,
    label: version.prompt,
    type,
    options: version.config?.options,
    config: version.config,
    description: version.instructions,
    photoRequired: version.evidence?.photoRequired === true,
    minPhotos:
      typeof version.evidence?.minPhotos === 'number' ? version.evidence.minPhotos : undefined,
    required: false,
    sortOrder,
  };
}

function builderItemType(type: QuestionVersion['type']): FormItemType {
  return type === 'PHOTO' ? 'IMAGE_UPLOAD' : type;
}
